module.exports = __webpack_public_path__ + "img/exit.320461f2.svg";